import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import ScrollProgress from "./ScrollProgress";
import SmoothScroll from "./SmoothScroll";
import Grain from "./Grain";

export default function Layout() {
  const location = useLocation();
  return (
    <div className="min-h-screen flex flex-col relative">
      <ScrollToTop />
      <ScrollProgress />
      <SmoothScroll />
      <Grain />
      <Navbar />
      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          className="flex-1 pt-16 md:pt-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.33, 1, 0.68, 1] }}
        >
          <Outlet />
        </motion.main>
      </AnimatePresence>
      <Footer />
    </div>
  );
}
